<template>
  <Table
    :fields="tableFields"
    :items="items"
  />
</template>

<script>
import Table from '@/components/project/molecules/Table.vue'
import { formatCurrency } from '@/filters'

import { FIELDS } from '../enums/installments-fees-fields.enum'

export default {
  name: 'InstallmentsTable',
  components: {
    Table
  },
  props: {
    installments: {
      type: Array,
      required: true
    }
  },
  methods: {
    formatInstallment (number) {
      return this.$t('installment', { number })
    },
    formatTotalValue (total, totalFees) {
      if (totalFees > 0) {
        return this.$t('hasFeeTotalValue', {
          total: formatCurrency(total),
          totalFees: formatCurrency(totalFees)
        })
      }

      return this.$t('noFeeTotalValue', {
        total: formatCurrency(total)
      })
    }
  },
  computed: {
    items () {
      return this.installments.map(({ number, total, totalFees }) => ({
        installment: this.formatInstallment(number),
        totalValue: this.formatTotalValue(total, totalFees)
      }))
    },
    tableFields () {
      return FIELDS.map(field => ({
        ...field,
        label: this.$t(field.label)
      }))
    }
  }
}
</script>
<i18n>
    {
        "pt-BR": {
            "installment": "Em até {number}x",
            "hasFeeTotalValue": "{total} ({totalFees} de acréscimo no preço)",
            "noFeeTotalValue": "{total} (sem acréscimo no preço)",
            "list": {
                "installment": "Parcelamento",
                "totalValue": "Valor total"
            }
        },
        "en-US": {
            "installment": "Installment {number}x",
            "hasFeeTotalValue": "{total} ({totalFees} of fees)",
            "noFeeTotalValue": "{total} (no fees)",
            "list": {
                "installment": "Installment",
                "totalValue": "Total value"
            }
        }
    }
</i18n>
